module.exports = __webpack_public_path__ + "/images/icon-smiley-32.582ab55.png";